import type {
  IntegrationProviderCapability,
  IntegrationProviderCapabilityType,
  IntegrationProviderType,
  IntegrationSettingName,
} from '@/api/integration';

type GetAudienceCapabilityProps = {
  provider: IntegrationProviderType;
  capabilityId: IntegrationProviderCapability;
};

export const getAudienceCapability = ({ provider, capabilityId }: GetAudienceCapabilityProps) => {
  return provider?.capabilities?.find((capability) => capability.id === capabilityId);
};

type GetAudienceSettingFromCapabilityProps = {
  capability?: IntegrationProviderCapabilityType;
  settingName: IntegrationSettingName;
};

export const getAudienceSettingFromCapability = ({
  capability,
  settingName,
}: GetAudienceSettingFromCapabilityProps) => {
  return capability?.settings?.find((setting) => setting.name === settingName);
};

type GetAudienceCapabilitySettingsProps = {
  provider: IntegrationProviderType;
  capabilityId: IntegrationProviderCapability;
  settingName: IntegrationSettingName;
};

export const getAudienceCapabilitySetting = ({
  provider,
  capabilityId,
  settingName,
}: GetAudienceCapabilitySettingsProps) => {
  const capability = getAudienceCapability({ provider, capabilityId });
  return capability?.settings?.find((setting) => setting.name === settingName);
};
